import {isEmpty} from "../../../../_helpers/commonFunctions";

export const productsPathConfig = [
    {
        id: "products",
        title: "ProductsSideBar.Products.title",
        key: "products",
        permission: "products-products",
        linkInfo: [
            {
                key: "products-new",
                id: "products-new",
                name: "ProductsSideBar.Products.new",
                permission: "products-products/new-read",
            },
            {
                key: "products-search",
                id: "products-search",
                name: "ProductsSideBar.Products.search",
                permission: "products-products/search-read",
            },
        ],
    },
    {
        key: "productMovements",
        id: "productsMovement",
        title: "ProductsSideBar.Movements.title",
        permission: "products-productsmovements",
        linkInfo: [
            {
                key: "productMovements-new",
                id: "product-movements-new",
                name: "ProductsSideBar.Movements.new",
                permission: "products-productsmovements/new-read",
            },
            {
                key: "productMovements-search",
                id: "product-movements-search",
                name: "ProductsSideBar.Movements.search",
                permission: "products-productsmovements/search-read",
            },
        ],
    },
    {
        key: "products-priceList",
        id: "pricelist",
        title: "ProductsSideBar.List.title",
        permission: "products-pricelist",
        linkInfo: [
            {
                key: "products-priceList-new",
                id: "product-pricelist-new",
                name: "ProductsSideBar.List.new",
                permission: "products-pricelist/new-general-read"
            },
            {
                key: "products-priceList-search",
                id: "pricelist-search",
                name: "ProductsSideBar.List.search",
                permission: "products-pricelist/search-read",
            },
        ],
    },
    {
        key: "products-reports",
        id: "reports",
        title: "ProductsSideBar.Reports.title",
        permission: "products-reports",
        linkInfo: [
            {
                key: "products-reports-balanceSheet",
                id: "product-balancesheet-reports",
                name: "ProductsSideBar.Reports.balanceSheet",
                permission: "products-reports/balancesheet-read",
            },
            {
                key: "products-reports-productMovements",
                id: "product-movments-reports",
                name: "ProductsSideBar.Reports.productMovements",
                permission: "products-reports/productmovements-read",
            },
        ],
    },
    {
        key: "products-settings",
        id: "settings",
        title: "ProductsSideBar.Settings.title",
        permission: "products-settings",
        linkInfo: [
            {
                key: "products-settings-productCategories",
                id: "products-settings-product-categories",
                name: "ProductsSideBar.Settings.productCategories",
                permission: "products-settings/productcategories-read"
            },
        ],
    },
];

export const salesPathConfig = [
    {
        key: "sales-sales",
        id: "sales",
        title: "SalesSideBar.Sales.title",
        permission: "sales-sales",
        linkInfo: [
            {
                key: "sales-new",
                id: "sales-new",
                name: "SalesSideBar.Sales.new",
                permission: "sales-sales/new-read",
                requirement: (COMPANY_DATA) => {
                    const user = JSON.parse(localStorage.getItem("user"));
                    const permissions = user?.permissions || [];
                    const primaryCompany = user?.primaryCompany;
                    const isCompanyCreator = permissions.some((p) => p.permissionName === "custom-companyCreator");
                    if (isCompanyCreator && primaryCompany && COMPANY_DATA.company.id !== primaryCompany) {
                        if (
                            isEmpty(COMPANY_DATA.companyDetails.primerMyDataApiUsername)
                            && isEmpty(COMPANY_DATA.companyDetails.primerMyDataApiPassword)
                            && isEmpty(COMPANY_DATA.companyDetails.primerMyDataApiSerialNumber)
                        ) {
                            return false;
                        }
                    }
                    return true;
                },
            },
            {
                key: "sales-search",
                id: "sales-search",
                name: "SalesSideBar.Sales.search",
                permission: "sales-sales/search-read"
            }
        ],
    },
    {
        id: "dcl",
        title: "Ψηφιακό Πελατολόγιο",
        key: "dcl",
        permission: "sales-dcl",
        requirement: (COMPANY_DATA) => {
            return !COMPANY_DATA.companyDetails?.hideDCL;
        },
        linkInfo: [
            {
                key: "new-dcl",
                id: "new-dcl",
                name: "Εισαγωγή",
                permission: "sales-dcl/new-read",
            },
            {
                key: "search-dcl",
                id: "search-dcl",
                name: "Αναζήτηση",
                permission: "sales-dcl/search-read"
            },
        ],
    },
    {
        id: "transfers",
        title: "Διακινήσεις",
        key: "transfers",
        permission: "custom-deliverynote",
        linkInfo: [
            {
                key: "new-transfer",
                id: "new-transfer",
                name: "Εισαγωγή",
                permission: "custom-deliverynote",
            },
            {
                key: "search-transfers",
                id: "search-transfers",
                name: "Αναζήτηση",
                permission: "custom-deliverynote"
            },
            {
                key: "generated-group-qrs",
                id: "generated-group-qrs",
                name: "Ομαδικοί Κωδικοί QR",
                permission: "custom-deliverynote"
            }
        ],
    },
    {
        key: "client-payments",
        id: "client-payments",
        title: "SalesSideBar.ClientPayments.title",
        permission: "sales-clientpayments",
        linkInfo: [
            {
                key: "client-payments-new-general-write",
                id: "new-client-payments",
                name: "SalesSideBar.ClientPayments.new",
                permission: "sales-clientpayments/new-read",
            },
            {
                key: "client-payments-search-search",
                id: "search-client-payments",
                name: "SalesSideBar.ClientPayments.search",
                permission: "sales-clientpayments/search-read"
            },
            {
                key: "primer-client-payments",
                id: "primer-client-payments",
                name: "Μαζ. Εισαγωγή (P)",
                permission: "sales-clientpayments/primer-read",
                requirement: (COMPANY_DATA) => ["800566476"].includes(COMPANY_DATA.company.vatNumber),
            },
            {
                key: "emron-client-payments",
                id: "emron-client-payments",
                name: "Μαζ. Εισαγωγή (E)",
                permission: "sales-clientpayments/emron-read",
                requirement: (COMPANY_DATA) => ["800434990"].includes(COMPANY_DATA.company.vatNumber),
            }
        ],
    },
    {
        key: "send-my-data-data",
        id: "my-data",
        title: "SalesSideBar.MyData.title",
        permission: "sales-mydata",
        linkInfo: [
            {
                key: "send-my-data-report",
                id: "mydata-report",
                name: "SalesSideBar.MyData.report",
                permission: "sales-mydata/mydatareport-read",
            },
            {
                key: "classifications-report",
                id: "classifications-report",
                name: "Αναφορά Χαρακτηρισμών",
                permission: "sales-mydata/mydatareport-read",
            }
        ],
    },
    {
        key: "sales-quotations",
        id: "quotations",
        title: "Προσφορές",
        permission: "sales-quotations",
        requirement: (COMPANY_DATA) => {
            const user = JSON.parse(localStorage.getItem("user"));
            const permissions = user?.permissions || [];
            const primaryCompany = user?.primaryCompany;
            const isCompanyCreator = permissions.some((p) => p.permissionName === "custom-companyCreator");
            if (isCompanyCreator && primaryCompany && COMPANY_DATA.company.id !== primaryCompany) {
                return false;
            }
            return true;
        },
        linkInfo: [
            {
                key: "sales-quotations-new",
                id: "sales-quotations-new",
                name: "Εισαγωγή",
                permission: "sales-quotations/new-read",
            },
            {
                key: "sales-quotations-search",
                id: "sales-quotations-search",
                name: "Αναζήτηση",
                permission: "sales-quotations/search-read"
            },
            {
                key: "primer-ai-url",
                id: "primer-ai-url",
                name: "SalesSideBar.Sales.primer-ai-url",
                permission: "sales-quotations/primerai-read",
                requirement: (COMPANY_DATA) => ["800566476"].includes(COMPANY_DATA.company.vatNumber),
            }
        ]
    },
    {
        key: "sales-reports",
        id: "reports",
        title: "SalesSideBar.Reports.title",
        permission: "sales-reports",
        linkInfo: [
            {
                key: "sales-report-balance-sheet",
                id: "sales-balance-sheet",
                name: "SalesSideBar.Reports.salesBalanceSheet",
                permission: "sales-reports/salesbalancesheet-read",
            },
            {
                key: "sales-reports-client-payment-report",
                id: "client-payments-report",
                name: "SalesSideBar.Reports.clientPaymentReport",
                permission: "sales-reports/clientpaymentreport-read"
            },
            {
                key: "sales-reports-graphic-report",
                id: "sales-graphic-report",
                name: "SalesSideBar.Reports.salesGraphicReport",
                permission: "sales-reports/salesgraphicreport-read",
            },
            {
                key: "sales-report-monthly-turnover",
                id: "sales-monthly-turnover",
                name: "SalesSideBar.Reports.monthlyTurnover",
                permission: "sales-reports/salesmonthlyturnover-read",
            },
        ],
    },
    {
        key: "sales-settings",
        id: "settings",
        title: "SalesSideBar.Settings.title",
        permission: "sales-settings",
        linkInfo: [
            {
                key: "sales-settings-general",
                id: "sales-general-settings",
                name: "SalesSideBar.Settings.SalesGeneralSettings",
                permission: "sales-settings/salesgeneralsettings-read",
            },
        ],
    },
];

export const buysPathConfig = [
    {
        key: "buys-buys",
        id: "buys",
        title: "BuysSideBar.Buys.title",
        permission: "buys-buy",
        linkInfo: [
            {
                key: "buys-new",
                id: "buys-new",
                name: "BuysSideBar.Buys.new",
                permission: "buys-buy/new-read",
            },
            {
                key: "buys-search",
                id: "buys-search",
                name: "BuysSideBar.Buys.search",
                permission: "buys-buy/search-read",
            },
        ],
    },
    {
        key: "supplier-payments",
        id: "supplier-payments",
        title: "BuysSideBar.SupplierPayments.title",
        permission: "buys-supplierpayments",
        linkInfo: [
            {
                key: "supplier-payments-new-general-write",
                id: "new-supplier-payments",
                name: "BuysSideBar.SupplierPayments.new",
                permission: "buys-supplierpayments/new-read",
            },
            {
                key: "supplier-payments-search-search",
                id: "search-supplier-payments",
                name: "BuysSideBar.SupplierPayments.search",
                permission: "buys-supplierpayments/search-read",
            },
        ],
    },
    {
        key: "buys-mydata-report",
        id: "buys-mydata-report",
        title: "BuysSideBar.MyData.title",
        permission: "buys-mydata",
        linkInfo: [
            {
                key: "buys-mydata-report",
                id: "buys-mydata-report",
                name: "BuysSideBar.MyData.report",
                permission: "buys-mydata/mydatareport-read",
            },
            {
                key: "classifications-report",
                id: "classifications-report",
                name: "Αναφορά Χαρακτηρισμών",
                permission: "buys-mydata/mydatareport-read",
            }
        ]
    },
    {
        key: "buys-reports",
        id: "reports",
        title: "BuysSideBar.Reports.title",
        permission: "buys-reports",
        linkInfo: [
            {
                key: "buys-report-balance-sheet",
                id: "buys-balance-sheet",
                name: "BuysSideBar.Reports.buysBalanceSheet",
                permission: "buys-reports/buybalancesheet-read",
            },
            {
                key: "buys-reports-supplier-payment-report",
                id: "supplier-payments-report",
                name: "BuysSideBar.Reports.supplierPaymentsReport",
                permission: "buys-reports/supplierpaymentreport-read",
            },
            {
                key: "buys-reports-graphic-report",
                id: "buys-graphic-report",
                name: "BuysSideBar.Reports.buysGraphicReport",
                permission: "buys-reports/buygraphicreport-read",
            },
            {
                key: "buys-report-monthly-turnover",
                id: "buys-monthly-turnover",
                name: "BuysSideBar.Reports.monthlyTurnover",
                permission: "buys-reports/buysmonthlyturnover-read",
            },
        ],
    },
    {
        key: "buys-settings",
        id: "settings",
        title: "BuysSideBar.Settings.title",
        permission: "buys-settings",
        linkInfo: [
            {
                key: "buys-settings-general",
                id: "buys-general-settings",
                name: "BuysSideBar.Settings.buysGeneralSettings",
                permission: "buys-settings/buygeneralsettings-read"
            }
        ]
    },
]

export const clientsPathConfig = [
    {
        key: "clients",
        id: "clients",
        title: "ClientSideBar.General.title",
        permission: "clients-clients",
        linkInfo: [
            {
                key: "new-client",
                id: "new-client",
                name: "ClientSideBar.General.general",
                permission: "clients-clients/new-read",
            },
            {
                key: "search-client",
                id: "search-client",
                name: "ClientSideBar.General.search",
                permission: "clients-clients/search-read",
            },
        ],
    },
    {
        key: "client-movements",
        id: "client-movements",
        title: "ClientSideBar.Movements.title",
        permission: "clients-clientmovements",
        linkInfo: [
            {
                key: "new-client-movements",
                id: "new-client-movements",
                name: "ClientSideBar.Movements.general",
                permission: "clients-clientmovements/new-read",
            },
            {
                key: "search-client-movements",
                id: "search-client-movements",
                name: "ClientSideBar.Movements.search",
                permission: "clients-clientmovements/search-read",
            },
        ],
    },
    {
        key: "client-reports",
        id: "reports",
        title: "ClientSideBar.Reports.title",
        permission: "clients-reports",
        linkInfo: [
            {
                key: "client-balance",
                id: "client-balance",
                name: "ClientSideBar.Reports.clientBalance",
                permission: "clients-reports/clientbalance-read",
            },
            {
                key: "clients-movements",
                id: "clients-movements",
                name: "ClientSideBar.Reports.clientsMovements",
                permission: "clients-reports/clientsmovements-read",
            },
            {
                key: "report-client-isozygio",
                id: "report-client-isozygio",
                name: "Ισοζύγιο Πελατών",
                permission: "clients-reports/clientisozygio-read",
            },
            {
                key: "emron-payments",
                id: "emron-payments",
                name: "Μηνιαίες Χρεώσεις",
                permission: "clients-reports/emronpayments-read",
                requirement: (COMPANY_DATA) => ["800434990"].includes(COMPANY_DATA.company.vatNumber),
            },
            {
                key: "reports-client-subscriptions",
                id: "reports-client-subscriptions",
                name: "Συνδρομές Πελατών",
                permission: "clients-reports/reportsclientsubscriptions-read",
                requirement: (COMPANY_DATA) => ["800566476"].includes(COMPANY_DATA.company.vatNumber),
            },
            {
                key: "reports-primer-payments",
                id: "reports-primer-payments",
                name: "Πληρωμές Συνδρομών",
                permission: "clients-reports/reportsprimerpayments-read",
                requirement: (COMPANY_DATA) => ["800566476"].includes(COMPANY_DATA.company.vatNumber),
            },
            {
                key: "reports-primer-payments-admin",
                id: "reports-primer-payments-admin",
                name: "Πράξεις Συνδρομών",
                permission: "clients-reports/reportsprimerpaymentsadmin-read",
                requirement: (COMPANY_DATA) => ["800566476"].includes(COMPANY_DATA.company.vatNumber),
            },
            {
                key: "reports-emron-settlements",
                id: "reports-emron-settlements",
                name: "Ανάλυση Διακανονισμών",
                permission: "clients-reports/reportsemronsettlements-read",
                requirement: (COMPANY_DATA) => ["800434990"].includes(COMPANY_DATA.company.vatNumber),
            },
            {
                key: "report-client-provider-contracts",
                id: "report-client-provider-contracts",
                name: "Συμβόλαια Παρόχου",
                permission: "clients-reports/reportsclientcontracts-read",
                requirement: (COMPANY_DATA) => ["800566476"].includes(COMPANY_DATA.company.vatNumber),
            }
        ],
    },
    {
        key: "primer-pos-main",
        id: "primer-pos-main",
        title: "Διαχείριση Συσκευών POS",
        permission: "clients-pos",
        requirement: (COMPANY_DATA) => ["800566476"].includes(COMPANY_DATA.company.vatNumber),
        linkInfo: [
            {
                key: "reports-primer-pos",
                id: "reports-primer-pos",
                name: "Διαχείριση POS",
                permission: "clients-pos/pos-read"
            },
            {
                key: "primer-pos-search-list",
                id: "primer-pos-search-list",
                name: "Λίστες Αποστολής ACS",
                permission: "clients-pos/posList-read"
            }
        ],
    },
    {
        key: "clients-settings-main",
        id: "clients-settings-main",
        title: "ClientSideBar.Settings.title",
        permission: "clients-settings",
        linkInfo: [
            {
                key: "clients-settings",
                id: "clients-settings",
                name: "ClientSideBar.Settings.clientSettings",
                permission: "clients-settings/clientsettings-read"
            },
        ],
    },
];

export const suppliersPathConfig = [
    {
        key: "suppliers",
        id: "suppliers",
        title: "SupplierSideBar.General.title",
        permission: "suppliers-suppliers",
        linkInfo: [
            {
                key: "new-supplier",
                id: "new-supplier",
                name: "SupplierSideBar.General.new",
                permission: "suppliers-suppliers/new-read",
            },
            {
                key: "search-supplier",
                id: "search-supplier",
                name: "SupplierSideBar.General.search",
                permission: "suppliers-suppliers/search-read",
            },
        ],
    },
    {
        key: "supplier-movements",
        id: "supplier-movements",
        title: "SupplierSideBar.Movements.title",
        permission: "suppliers-suppliermovements",
        linkInfo: [
            {
                key: "new-supplier-movements",
                id: "new-supplier-movements",
                name: "SupplierSideBar.Movements.new",
                permission: "suppliers-suppliermovements/new-read",
            },
            {
                key: "search-supplier-movements",
                id: "search-supplier-movements",
                name: "SupplierSideBar.Movements.search",
                permission: "suppliers-suppliermovements/search-read",
            },
        ],
    },
    {
        key: "supplier-reports",
        id: "reports",
        title: "SupplierSideBar.Reports.title",
        permission: "suppliers-reports",
        linkInfo: [
            {
                key: "supplier-balance",
                id: "supplier-balance",
                name: "SupplierSideBar.Reports.supplierBalance",
                permission: "suppliers-reports/supplierbalance-read"
            },
            {
                key: "suppliers-movements",
                id: "suppliers-movements",
                name: "SupplierSideBar.Reports.supplierMovements",
                permission: "suppliers-reports/suppliersmovements-read",
            },
            {
                key: "report-supplier-isozygio",
                id: "report-supplier-isozygio",
                name: "Ισοζύγιο Προμηθευτών",
                permission: "suppliers-reports/supplierisozygio-read",
            },
        ],
    },
    {
        key: "suppliers-settings-main",
        id: "suppliers-settings-main",
        title: "SupplierSideBar.Settings.title",
        permission: "suppliers-settings",
        linkInfo: [
            {
                key: "suppliers-settings",
                id: "suppliers-settings",
                name: "SupplierSideBar.Settings.supplierSettings",
                permission: "suppliers-settings/suppliersettings-read",
            },
        ],
    },
];

export const cashRegistersConfig = [
    {
        key: "cash-registers",
        id: "cash-registers",
        title: "Cash.CashRegisters.title",
        permission: "cash-cashregisters",
        linkInfo: [
            {
                key: "cash-registers-new",
                id: "cash-registers-new",
                name: "Cash.CashRegisters.new",
                permission: "cash-cashregisters/new-read",
            },
            {
                key: "cash-registers-search",
                id: "cash-registers-search",
                name: "Cash.CashRegisters.search",
                permission: "cash-cashregisters/search-read",
            },
        ],
    },
    {
        key: "pos",
        id: "pos",
        title: "Cash.POS.title",
        permission: "cash-pos",
        linkInfo: [
            {
                key: "new-pos",
                id: "new-pos",
                name: "Cash.POS.new",
                permission: "cash-pos/new-read"
            },
            {
                key: "search-pos",
                id: "search-pos",
                name: "Cash.POS.search",
                permission: "cash-pos/search-read",
            },
        ],
    },
    {
        key: "bank-accounts",
        id: "bank-accounts",
        title: "Cash.bankAccounts.title",
        permission: "cash-bankaccounts",
        linkInfo: [
            {
                key: "new-bank-account",
                id: "new-bank-account",
                name: "Cash.bankAccounts.new",
                permission: "cash-bankaccounts/new-read",
            },
            {
                key: "search-bank-account",
                id: "search-bank-account",
                name: "Cash.bankAccounts.search",
                permission: "cash-bankaccounts/search-read",
            },
        ],
    },
    {
        key: "cheques",
        id: "cheques",
        title: "Επιταγές",
        permission: "cash-cheques",
        linkInfo: [
            {
                key: "new-cheque",
                id: "new-cheque",
                name: "Εισαγωγή",
                permission: "cash-cheques/new-read",
            },
            {
                key: "search-cheques",
                id: "search-cheques",
                name: "Αναζήτηση",
                permission: "cash-cheques/search-read",
            },
            {
                key: "cheque-report",
                id: "cheque-report",
                name: "Αναφορά Επιταγών",
                permission: "cash-cheques/report-read",
            }
        ],
    },
    {
        key: "loans",
        id: "loans",
        title: "Δάνεια",
        permission: "cash-loans",
        linkInfo: [
            {
                key: "new-loan",
                id: "new-loan",
                name: "Εισαγωγή",
                permission: "cash-loans/new-read",
            },
            {
                key: "search-loans",
                id: "search-loans",
                name: "Αναζήτηση",
                permission: "cash-loans/search-read",
            },
            {
                key: "loan-report",
                id: "loan-report",
                name: "Αναφορά Δανείων",
                permission: "cash-loans/report-read",
            }
        ],
    },
    {
        key: "cards",
        id: "cards",
        title: "Κάρτες",
        permission: "cash-cards",
        linkInfo: [
            {
                key: "cards-new",
                id: "cards-new",
                name: "Εισαγωγή",
                permission: "cash-cards/new-read",
            },
            {
                key: "cards-search",
                id: "cards-search",
                name: "Αναζήτηση",
                permission: "cash-cards/search-read",
            },
        ],
    },
    {
        key: "cash-banking",
        id: "cash-banking",
        title: "Όψεως",
        permission: "cash-banking",
        linkInfo: [
            {
                key: "accounting-banking-transactions",
                id: "accounting-banking-transactions",
                name: "Τραπεζικές Συναλλαγές",
                permission: "cash-banking/bankingtransactions-read",
                requirement: (COMPANY_DATA, options) => !options.hasBankingAI || options.isAdmin,
            },
            {
                key: "accounting-ai-banking-transactions",
                id: "accounting-ai-banking-transactions",
                name: "Τραπεζικές Συναλλαγές ΑΙ",
                permission: "cash-banking/bankingtransactions-read",
                requirement: (COMPANY_DATA, options) => options.hasBankingAI || options.isAdmin,
            },
            {
                key: "accounting-banking-agreements",
                id: "accounting-banking-agreements",
                name: "Τραπεζικές Διασυνδέσεις",
                permission: "cash-banking/bankingagreements-read",
            },
            {
                key: "banking-settings",
                id: "banking-settings",
                name: "Ρυθμίσεις Όψεως",
                permission: "cash-banking/settings-read",
            },
            {
                key: "accounting-banking-agreements-admin",
                id: "accounting-banking-agreements-admin",
                name: "Τραπεζικές Διασυνδέσεις (E)",
                permission: "custom-admin",
            },
        ]
    },
    {
        key: "cash-registers-settings",
        id: "settings",
        title: "Cash.Settings.title",
        permission: "cash-settings",
        linkInfo: [
            {
                key: "cash-settings-accounting",
                id: "cash-settings-accounting",
                name: "Λογιστική",
                permission: "cash-settings/accounting-read",
            }
        ],
    },
];

export const accountingPathConfig = [
    {
        id: "employee",
        title: "AccountingSideBar.Employee.title",
        key: "employee",
        permission: "accounting-employees",
        linkInfo: [
            {
                key: "employee-new",
                id: "employee-new",
                name: "AccountingSideBar.Employee.new",
                permission: "accounting-employees/new-read",
            },
            {
                key: "employee-search",
                id: "employee-search",
                name: "AccountingSideBar.Employee.search",
                permission: "accounting-employees/search-read"
            },
        ],
    },
    {
        id: "accounting-account",
        title: "AccountingSideBar.AccountingAccounts.title",
        key: "accounting-account",
        permission: "accounting-accountingaccounts",
        linkInfo: [
            {
                key: "accounting-account-new",
                id: "accounting-account-new",
                name: "AccountingSideBar.AccountingAccounts.new",
                permission: "accounting-accountingaccounts/new-read",
            },
            {
                key: "accounting-account-search",
                id: "accounting-account-search",
                name: "AccountingSideBar.AccountingAccounts.search",
                permission: "accounting-accountingaccounts/search-read"
            },
        ],
    },
    {
        key: "accounting-records",
        id: "accounting-records",
        title: "AccountingSideBar.AccountingRecords.title",
        permission: "accounting-accountingrecords",
        linkInfo: [
            {
                key: "accounting-record-new",
                id: "accounting-record-new",
                name: "AccountingSideBar.AccountingRecords.new",
                permission: "accounting-accountingrecords/new-read",
            },
            {
                key: "accounting-record-search",
                id: "accounting-record-search",
                name: "AccountingSideBar.AccountingRecords.search",
                permission: "accounting-accountingrecords/search-read",
            },
            {
                key: "accounting-closure",
                id: "accounting-closure",
                name: "Κλείσιμο Λογαριασμών",
                permission: "accounting-accountingrecords/closure-read",
            }
        ],
    },
    {
        key: "accounting-reports",
        id: "accounting-reports",
        title: "AccountingSideBar.Reports.title",
        permission: "accounting-reports",
        linkInfo: [
            {
                key: "accounting-report-isozygio",
                id: "accounting-report-isozygio",
                name: "Ισοζύγιο",
                permission: "accounting-reports/isozygio-read"
            },
            {
                key: "accounting-report-accounts",
                id: "accounting-report-accounts",
                name: "Καρτέλα Λογαριασμών",
                permission: "accounting-reports/accounts-read"
            },
            {
                key: "accounting-report-calendar",
                id: "accounting-report-calendar",
                name: "Ημερολόγιο Λογαριασμών",
                permission: "accounting-reports/calendar-read"
            },
            {
                key: "accounting-report-general-calendar",
                id: "accounting-report-general-calendar",
                name: "Γενικό Ημερολόγιο",
                permission: "accounting-reports/calendar-read"
            },
            {
                key: "accounting-operating-statement",
                id: "accounting-operating-statement",
                name: "Γενική Εκμετάλλευση",
                permission: "accounting-reports/operatingstatement-read",
            },
            {
                key: "accounting-ie-book",
                id: "accounting-ie-book",
                name: "Βιβλίο Εσόδων/Εξόδων",
                permission: "accounting-reports/iebook-read",
            },
            {
                key: "accounting-year-report",
                id: "accounting-year-report",
                name: "Ετήσια Αποτελέσματα",
                permission: "accounting-reports/year-read",
            }
        ],
    },
    {
        key: "accounting-forms",
        id: "accounting-forms",
        title: "AccountingSideBar.Forms.title",
        permission: "accounting-forms",
        linkInfo: [
            {
                key: "accounting-f2-doc",
                id: "accounting-f2-doc",
                name: "Φ2",
                permission: "accounting-forms/f2",
                subLinks: [
                    {
                        key: "accounting-issue-vat-information",
                        id: "accounting-issue-vat-information",
                        name: "Έκδοση",
                        permission: "accounting-forms/f2-write",
                    },
                    {
                        key: "accounting-submitted-declarations",
                        id: "accounting-submitted-declarations",
                        name: "Αναζήτηση",
                        permission: "accounting-forms/f2-read",
                    },
                    {
                        key: "accounting-report-vat-information",
                        id: "accounting-report-vat-information",
                        name: "Αναφορά Φ2 MyData",
                        permission: "accounting-forms/f2-read",
                    }
                ],
            },
            {
                key: "accounting-f4-doc",
                id: "accounting-f4-doc",
                name: "Φ4",
                permission: "accounting-forms/f4",
                subLinks: [
                    {
                        key: "accounting-issue-f4-vat-information",
                        id: "accounting-issue-f4-vat-information",
                        name: "Έκδοση",
                        permission: "accounting-forms/f4-write",
                    },
                    {
                        key: "accounting-submitted-f4-declarations",
                        id: "accounting-submitted-f4-declarations",
                        name: "Αναζήτηση",
                        permission: "accounting-forms/f4-read",
                    }
                ],
            },
            {
                key: "accounting-f5-doc",
                id: "accounting-f5-doc",
                name: "Φ5",
                permission: "accounting-forms/f5",
                subLinks: [
                    {
                        key: "accounting-issue-f5-vat-information",
                        id: "accounting-issue-f5-vat-information",
                        name: "Έκδοση",
                        permission: "accounting-forms/f5-write",
                    },
                    {
                        key: "accounting-submitted-f5-declarations",
                        id: "accounting-submitted-f5-declarations",
                        name: "Αναζήτηση",
                        permission: "accounting-forms/f5-read",
                    }
                ]
            }
        ]
    },
    {
        key: "accounting-debts",
        id: "accounting-debts",
        title: "AccountingSideBar.Debts.title",
        permission: "accounting-debts",
        linkInfo: [
            {
                key: "accounting-debts-search",
                id: "accounting-debts-search",
                name: "AccountingSideBar.Debts.search",
                permission: "accounting-debts/search-read",
            }
        ]
    },
    {
        key: "accounting-settings",
        id: "accounting-settings",
        title: "AccountingSideBar.Settings.title",
        permission: "accounting-settings",
        linkInfo: [
            {
                key: "accounting-settings",
                id: "accounting-settings",
                name: "AccountingSideBar.Settings.accounting",
                permission: "accounting-settings/accounting-read",
            },
            {
                id: "accounting-record-settings",
                key: "accounting-record-settings",
                name: "AccountingSideBar.Settings.recordTemplates",
                permission: "accounting-settings/recordtemplates-read",
            },
            {
                id: "accounting-bridge-settings",
                key: "accounting-bridge-settings",
                name: "Γέφυρα",
                permission: "accounting-settings/bridge-read",
            }
        ],
    },
];

export const payrollPathConfig = [
    {
        id: "employee",
        title: "AccountingSideBar.Employee.title",
        key: "employee",
        permission: "payroll-employees",
        linkInfo: [
            {
                key: "employee-new",
                id: "employee-new",
                name: "AccountingSideBar.Employee.new",
                permission: "payroll-employees/new-read",
            },
            {
                key: "employee-search",
                id: "employee-search",
                name: "AccountingSideBar.Employee.search",
                permission: "payroll-employees/search-read"
            },
        ],
    },
    {
        id: "working-program",
        title: "Πρόγραμμα Εργασίας",
        key: "working-program",
        permission: "payroll-workingprogram",
        linkInfo: []
    },
    {
        id: "payroll-qr-scanner",
        title: "Σαρωτής QR",
        key: "payroll-qr-scanner",
        permission: "payroll-qrscanner",
        linkInfo: []
    },
    {
        id: "work-permits",
        title: "Άδειες Εργαζομένων",
        key: "work-permits",
        permission: "payroll-workpermits",
        linkInfo: [
            {
                key: "new-work-permit",
                id: "new-work-permit",
                name: "Εισαγωγή",
                permission: "payroll-workpermits/new-read",
            },
            {
                key: "search-work-permits",
                id: "search-work-permits",
                name: "Αναζήτηση",
                permission: "payroll-workpermits/search-read"
            },
            {
                key: "work-permit-report",
                id: "work-permit-report",
                name: "Ανάλυση Αδειών",
                permission: "payroll-workpermits/search-read",
            },
        ],
    },
    {
        id: "workMovements",
        title: "Κινήσεις Εργαζομένων",
        key: "workMovements",
        permission: "payroll-workmovements",
        linkInfo: [
            {
                key: "new-work-movement",
                id: "new-work-movement",
                name: "Εισαγωγή",
                permission: "payroll-workmovements/new-read",
            },
            {
                key: "search-work-movements",
                id: "search-work-movements",
                name: "Αναζήτηση",
                permission: "payroll-workmovements/search-read"
            },
        ],
    },
    {
        id: "ergani-submissions-report",
        title: "Αιτήματα Εργάνης",
        key: "ergani-submissions-report",
        permission: "payroll-erganisubmissions",
        linkInfo: []
    },
    {
        id: "payroll-hour-report",
        title: "Ωρομέτρηση",
        key: "payroll-hour-report",
        permission: "payroll-hourreport",
        linkInfo: []
    },
    {
        id: "payroll-settings",
        title: "Ρυθμίσεις",
        key: "payroll-settings",
        permission: "payroll-settings",
        linkInfo: [
            {
                key: "payroll-settings",
                id: "payroll-settings",
                name: "Ρυθμίσεις Μισθοδοσίας",
                permission: "payroll-settings/settings-read",
            },
        ],
    },
]

export const prescriptionPathConfig = [
    {
        id: "prescription-home",
        title: "Αρχική",
        key: "prescription-home",
        permission: "prescription-home",
        linkInfo: [],
        dontShow: true, // Don't show before activation
    },
    {
        id: "visit-new",
        title: "Επίσκεψη",
        key: "visit-new",
        permission: "prescription-visit",
        linkInfo: [],
        dontShow: true,
    },
    {
        id: "prescription-searches",
        title: "Αναζητήσεις",
        key: "prescription-searches",
        permission: "prescription-searches",
        dontShow: true,
        linkInfo: [
            {
                key: "search-visits",
                id: "search-visits",
                name: "Επισκέψεων",
                permission: "prescription-searches/visits-read",
            },
            {
                key: "search-prescriptions",
                id: "search-prescriptions",
                name: "Συνταγών",
                permission: "prescription-searches/prescriptions-read",
            },
            {
                key: "search-referrals",
                id: "search-referrals",
                name: "Παραπεμπτικών",
                permission: "prescription-searches/referrals-read",
            },
            {
                key: "patient-history",
                id: "patient-history",
                name: "Ιστορικό Ασθενή",
                permission: "prescription-searches/patienthistory-read",
            },
            {
                key: "search-icd10s",
                id: "search-icd10s",
                name: "ICD-10",
                permission: "prescription-searches/icd10s-read",
            },
            {
                key: "search-drugs",
                id: "search-drugs",
                name: "Φαρμάκων",
                permission: "prescription-searches/drugs-read",
            },
            {
                key: "search-exams",
                id: "search-exams",
                name: "Εξετάσεων",
                permission: "prescription-searches/exams-read",
            },
        ]
    },
    {
        id: "prescription-reports",
        title: "Εκτυπώσεις",
        key: "prescription-reports",
        permission: "prescription-reports",
        dontShow: true,
        linkInfo: [
            {
                key: "reports-prescriptions",
                id: "reports-prescriptions",
                name: "Αναφορά Συνταγών",
                permission: "prescription-reports/prescriptions-read",
            },
            {
                key: "reports-drugs",
                id: "reports-drugs",
                name: "Συνταγογραφημένα Φάρμακα",
                permission: "prescription-reports/drugs-read",
            },
        ]
    },
    {
        id: "prescription-settings",
        title: "Ρυθμίσεις & Εργαλεία",
        key: "prescription-settings",
        permission: "prescription-settings",
        linkInfo: [
            {
                key: "prescription-monthly-invoicing",
                id: "prescription-monthly-invoicing",
                name: "Εργαλείο Τιμολόγησης",
                permission: "prescription-settings/settings-read",
            },
            {
                key: "prescription-settings",
                id: "prescription-settings",
                name: "Ρυθμίσεις Συνταγογράφησης",
                permission: "prescription-settings/settings-read",
            },
        ],
    },
]

export const settingsPathConfig = [
    {
        key: "primer-my-data",
        id: "primer-my-data",
        title: "SettingsSideBar.PrimerMyData.title",
        permission: "settings-primermydata",
        linkInfo: [
            {
                key: "primer-my-data",
                id: "primer-my-data",
                name: "SettingsSideBar.PrimerMyData.title",
                permission: "settings-primermydata/primermydata-read",
            },
            {
                key: "primer-my-data-data",
                id: "primer-my-data-data",
                name: "SettingsSideBar.PrimerMyData.data",
                permission: "settings-primermydata/data-read",
            },
        ],
    },
    {
        key: "settings-document-types",
        id: "settings-document-types",
        title: "SettingsSideBar.DocumentType.title",
        permission: "settings-documenttype",
        linkInfo: [
            {
                key: "basic-types-new",
                id: "basic-types-new",
                name: "SettingsSideBar.DocumentType.basicTypesNew",
                permission: "settings-documenttype/basictypesnew-read",
            },
            {
                key: "basic-types-search",
                id: "basic-types-search",
                name: "SettingsSideBar.DocumentType.basicTypesSearch",
                permission: "settings-documenttype/basictypessearch-read",
            },
            {
                key: "advanced-types-new",
                id: "advanced-types-new",
                name: "SettingsSideBar.DocumentType.advancedTypesNew",
                permission: "settings-documenttype/advancedtypesnew-read",
            },
            {
                key: "advanced-types-search",
                id: "advanced-types-search",
                name: "SettingsSideBar.DocumentType.advancedTypesSearch",
                permission: "settings-documenttype/advancedtypessearch-read",
            },
        ],
    },
    {
        key: "general-settings",
        id: "general-settings",
        title: "SettingsSideBar.GeneralSettings.title",
        permission: "settings-generalsettings",
        linkInfo: [
            {
                key: "company-settings",
                id: "company-settings",
                name: "SettingsSideBar.GeneralSettings.companySettings",
                permission: "settings-generalsettings/companysettings-read",
            },
            {
                key: "ai-settings",
                id: "ai-settings",
                name: "Ρυθμίσεις AI",
                permission: "settings-generalsettings/aisettings-read",
            },
            {
                key: "system-tasks",
                id: "system-tasks",
                name: "SettingsSideBar.GeneralSettings.systemTasks",
                permission: "settings-generalsettings/systemtasks-read",
            },
            {
                id: "email-smtp",
                key: "email-smtp",
                name: "SettingsSideBar.GeneralSettings.emailSTMP",
                permission: "settings-generalsettings/emailsmtp-read",
            },
            {
                id: "subscriptions",
                key: "subscriptions",
                name: "SettingsSideBar.GeneralSettings.subscriptions",
                permission: "settings-generalsettings/subscriptions-read",
            },
            {
                id: "master-log-search",
                key: "master-log-search",
                name: "SettingsSideBar.GeneralSettings.logHistory",
                permission: "settings-generalsettings/masterlogsearch-read"
            },
            {
                id: "reports-companies-ai-usage",
                key: "reports-companies-ai-usage",
                name: "SettingsSideBar.GeneralSettings.aiUsageCompaniesReport",
                permission: "custom-admin",
            }
        ],
    },
    {
        key: "import-export",
        id: "import-export",
        title: "SettingsSideBar.ImportExport.title",
        permission: "settings-importexport",
        linkInfo: [
            {
                key: "settings-import",
                id: "settings-import",
                name: "SettingsSideBar.ImportExport.import",
                permission: "settings-importexport/import-read",
            },
            {
                key: "settings-export",
                id: "settings-export",
                name: "SettingsSideBar.ImportExport.export",
                permission: "settings-importexport/export-read",
            },
        ],
    },
    {
        key: "backup-restore",
        id: "backup-restore",
        title: "SettingsSideBar.BackupRestore.title",
        permission: "settings-backuprestore",
        linkInfo: [
            {
                key: "settings-backup",
                id: "settings-backup",
                name: "SettingsSideBar.BackupRestore.backup",
                permission: "settings-backuprestore/backup-read",
            },
            {
                key: "settings-restore",
                id: "settings-restore",
                name: "SettingsSideBar.BackupRestore.restore",
                permission: "settings-backuprestore/restore-read",
            },
            {
                key: "component-playground",
                id: "component-playground",
                name: "Comp. Playground",
                permission: "custom-aaaaaaaaaaaaa",
            },
            {
                key: "settings-emronExpenses",
                id: "settings-emronExpenses",
                name: "Emron Expenses",
                permission: "settings-backuprestore/emronExpenses-read"
            }
        ],
    },
];

export const fixedAssetsPathConfig = [
    {
        id: "fixedassets",
        title: "Πάγια",
        key: "fixedassets",
        permission: "fixedassets-fixedassets",
        linkInfo: [
            {
                key: "new-fixed-asset",
                id: "new-fixed-asset",
                name: "Εισαγωγή",
                permission: "fixedassets-fixedassets/new-read",
            },
            {
                key: "search-fixed-assets",
                id: "search-fixed-assets",
                name: "Αναζήτηση",
                permission: "fixedassets-fixedassets/search-read",
            },
        ],
    },
    {
        id: "fixedassets-movements",
        title: "Κινήσεις Παγίων",
        key: "fixedassets-movements",
        permission: "fixedassets-movements",
        linkInfo: [
            {
                key: "new-fixed-asset-movement",
                id: "new-fixed-asset-movement",
                name: "Εισαγωγή",
                permission: "fixedassets-movements/new-read",
            },
            {
                key: "search-fixed-asset-movements",
                id: "search-fixed-asset-movements",
                name: "Αναζήτηση",
                permission: "fixedassets-movements/search-read",
            },
        ],
    },
    {
        id: "fixedassets-records",
        title: "Αποσβέσεις",
        key: "fixedassets-records",
        permission: "fixedassets-records",
        linkInfo: [
            {
                key: "new-fixed-asset-record",
                id: "new-fixed-asset-record",
                name: "Εισαγωγή",
                permission: "fixedassets-records/new-read",
            },
            {
                key: "search-fixed-asset-records",
                id: "search-fixed-asset-records",
                name: "Αναζήτηση",
                permission: "fixedassets-records/search-read",
            },
        ],
    },
    {
        id: "fixedassets-reports",
        title: "Εκτυπώσεις",
        key: "fixedassets-reports",
        permission: "fixedassets-reports",
        linkInfo: [
            {
                key: "report-fixed-asset-movements",
                id: "report-fixed-asset-movements",
                name: "Καρτέλες Παγίων",
                permission: "fixedassets-reports/movements-read",
            },
            {
                key: "report-fixed-asset-book",
                id: "report-fixed-asset-book",
                name: "Μητρώο/Βιβλίο Παγίων",
                permission: "fixedassets-reports/book-read",
            },
            {
                key: "report-sold-fixed-assets",
                id: "report-sold-fixed-assets",
                name: "Πωληθέντα Πάγια",
                permission: "fixedassets-reports/sold-read",
            },
        ]
    },
    {
        id: "fixedassets-settings",
        title: "Ρυθμίσεις",
        key: "fixedassets-settings",
        permission: "fixedassets-settings",
        linkInfo: [
            {
                key: "fixedassets-settings",
                id: "fixedassets-settings",
                name: "Ρυθμίσεις Παγίων",
                permission: "fixedassets-settings/settings-read",
            },
        ],
    },
]
